.forgot {
	font-size: var(--text-caption);
	float: right;
}

.error {
	color: var(--color-error-text);
	font-size: var(--text-caption);

	&:empty {
		display: none;
	}
}

.modalActions {
	display: flex;
	gap: var(--size-3);
	justify-content: flex-end;
	margin-top: var(--size-5);
}

.machine {
	display: flex;
	gap: var(--size-3);
	justify-content: center;
	align-items: center;
}
